import _ from 'underscore';
import template from '../template/keyword-bidlandscape.pug';
import { KeywordBidLandscapeViewModel } from './viewmodel';
import { BidLandscapeBaseView } from '../base-view';

/**
 * Keyword bid landscape
 * Display bid with estimated KPIs (click /impression) using both table & line chart
 */
export class KeywordBidLandscape extends BidLandscapeBaseView {
  get ViewModel() {
    return KeywordBidLandscapeViewModel;
  }

  get template() {
    return () => template(_.extend(this.viewModel, {
      isForVNext: this.isForVNext,
    }));
  }
}
